import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from "@mui/material/Checkbox";
import {useTranslation} from "react-i18next";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import DestDialog, {dstTypes} from './DestDialog.js'
import {getCityName} from './Trans.js';
import ObsAppBar from './AppBar.js';
import {COMM_OK} from './WsR2.js';

const DestList = observer((props) => {
	const [destDlgOpen, setDestDlgOpen] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const getheader = () => t('menu.destinations');

	function destListRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('destListRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'reg') {
			if (msg.op === 'dst_list') {
				if (msg.result === 'OK') {
					let dstlist = msg.data.regdst_list;

					dstlist.unshift({id: 0, city: '-', addr: '', lat_obs: 0, long_obs: 0});
					gStorage.lists.setDstList(dstlist);

					console.log('destListRxWs: dst list loading OK!');
				} else {
					console.error('destListRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else if (msg.op === 'list') {
				if (msg.result === 'OK') {
					let _reglist = {
						last_upd: msg.data.last_upd,
						list: msg.data.reglist
					};

					window.localStorage.setItem('reglist', JSON.stringify(_reglist));
					gStorage.lists.setRegList(_reglist);

					/* Refresh user list too */
					msg = {
						sess_id: gStorage.conn.sess_id,
						cmd: 'reg',
						op: 'dst_list'
					};

					gStorage.conn.ws.send(msg, dstRxWs);
				} else {
					console.error('destListRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('destListRxWs: unknown operation', msg.cmd, msg.op, msg.result);
			}
		} else {
			console.error('destListRxWs: invalid command', msg.cmd, msg.op);
		}
	}

	function destDlgClose(changed) {
		if (changed) {
			let msg = {
				sess_id: gStorage.conn.sess_id,
				cmd: 'reg',
				op: 'list'
			};

			gStorage.conn.ws.send(msg, destListRxWs);
		}

		setDestDlgOpen(false);
	}

	function toAddDst() {
		gStorage.destination.newDestination(true);
		setDestDlgOpen(true);
	}

	function editDst(dst) {
		gStorage.destination.setDestination({...dst}, false);
		setDestDlgOpen(true);
	}

	function dstGetCityName(id) {
		return getCityName(gStorage.lists.citylist.list.find(option => option.id === id), gStorage.conn.user);
	}
	
	function dstCitySort(p1, p2) {
		if (p1.id === 0)
			return -1;
		if (p2.id === 0)
			return 1;

		let ret = dstGetCityName(p1.city_id).localeCompare(dstGetCityName(p2.city_id), 'fi');
		if (ret)
			return ret;

		return p1.name.localeCompare(p2.name, 'fi');
	}

	function dstRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('tripListRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'reg') {
			if (msg.op === 'dst_toggle') {
				if (msg.result === 'OK') {
					let msg = {
						sess_id: gStorage.conn.sess_id,
						cmd: 'reg',
						op: 'dst_list'
					};

					gStorage.conn.ws.send(msg, dstRxWs);
				} else {
					console.error('dstRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else if (msg.op === 'dst_list') {
				if (msg.result === 'OK') {
					let dstlist = msg.data.regdst_list;

					dstlist.unshift({id: 0, city: '-', addr: '', lat_obs: 0, long_obs: 0});
					gStorage.lists.setDstList(dstlist);
				} else {
					console.error('dstRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('dstRxWs: invalid reg operation', msg.op);
			}
		} else {
			console.error('dstRxWs: invalid command', msg.cmd, msg.op);
			return -1;
		}
	}

	function dstMyChecked(dst) {
// 		console.log('dstMyChecked', dst.id);

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'reg',
			op: 'dst_toggle',
			data: {
				id: dst.id
			}
		};

		gStorage.conn.ws.send(msg, dstRxWs);
	}

	const dstList = gStorage.lists.reglist.list.slice().sort(dstCitySort);

	return (
		<div>
			<ObsAppBar getheader={getheader} add_action={toAddDst}/>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell padding='checkbox'>#</TableCell>
							<TableCell padding='checkbox'>{t('add.city')}</TableCell>
							<TableCell >{t('common.name')}</TableCell>
							<TableCell >{t('dest.type')}</TableCell>
							<TableCell padding='none' align='center'>{t('dest.in_use')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{dstList.map((reg, ind) => {
							let bg;

							if (reg.id === 0)
								return null;

							bg = reg.user_id === gStorage.conn.user.id ? '#e0f2f1' : '#ffffff';
// 							console.log(dst.name, dst.user_id, gStorage.conn.user.id, bg);

							return (
								<TableRow style={{backgroundColor: bg, cursor: 'pointer'}} key={reg.id}>
									<TableCell onClick={editDst.bind(this, reg)} padding='checkbox'>{ind + 1}</TableCell>
									<TableCell onClick={editDst.bind(this, reg)} padding='checkbox'>{dstGetCityName(reg.city_id)}</TableCell>
									<TableCell onClick={editDst.bind(this, reg)} >{reg.name}</TableCell>
									<TableCell onClick={editDst.bind(this, reg)} >{t(dstTypes.find((dstt) => dstt.id === reg.reg_type).dst_desc)}</TableCell>
									<TableCell padding='none' align='center'>
										<Checkbox style={{margin:0, padding:6}}
											indeterminate={false}
											checked={gStorage.lists.dstlist.find((dst) => reg.id === dst.id) ? true : false}
											onChange={dstMyChecked.bind(this, reg)}
											color={'primary'}
											disabled={!gStorage.conn.online}
										/>
									</TableCell>
								</TableRow>);
							})
						}
					</TableBody>
				</Table>
			</TableContainer>

			<DestDialog isOpen={destDlgOpen} handleClose={destDlgClose} />
		</div>
	);
});

export default DestList;
